import Swiper from "./../../imports/import-swiper";
import { gsap } from "gsap";
import { bindCursorHoverEffect } from "./../cursor.js";
export default () => {
  const container = document.querySelector(".experience-slider--general");
  if (container && screen.width > 1200) {
    const slides = container.querySelectorAll(".swiper-slide");
    slides.length > 3 ? runSliderSwipe() : false;
  }
  if (container && screen.width <= 1200) {
    const slides = container.querySelectorAll(".swiper-slide");
    slides.length > 1 ? runSliderSwipe() : false;
  }

  let itemsN = document.querySelectorAll('.experience-section__slide');
    itemsN.forEach(function(item) {
      let text = item.querySelector('.hidden-p');
      let textHeight = text.offsetHeight;
      text.style.height = 2 + 'px';
      
      item.addEventListener('mouseenter', (e) => {
        gsap.to(text, {
          height: textHeight,
          duration: 0.5
        });
       
      });
      item.addEventListener('mouseleave', (e) => {
        gsap.to(text, {
          height: 0,
          duration: 0.5,
          ease: "power2.inOut"
        });
        
      });
    });

  function runSliderSwipe() {
    const journalSlider = new Swiper(container, {
      effect: "slide",
      touchStartPreventDefault: false,
      allowTouchMove: true,
      loop: true,
      loopAdditionalSlides: 1,
      autoplay: {
        delay: 10000,
      },
      slidesPerView: 3,
      watchSlidesProgress: true,
      pagination: {
        el: ".experience-slider__pagination",
        type: "bullets",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span></span></span>';
        },
      },
      breakpoints: {
        900: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        448: {
          slidesPerView: 1,
          spaceBetween: 14,
        },
      },
      on: {
        slideChange: () => {
          bindCursorHoverEffect();
        },
      },
    });

    let sliders = container.querySelectorAll(".swiper-slide");
    sliders.forEach((slider) => {
      const text = slider.querySelector("p");
      const hiddenP = slider.querySelector(".hidden-p");
      const hiddenPHeight = hiddenP.offsetHeight;
      hiddenP.style.height = 0;
      slider.addEventListener("mouseover", () => {
        if (!document.documentElement.classList.contains("touch")) {
          gsap.to(hiddenP, {
            height: hiddenPHeight,
          });
          gsap.to(text, {
            y: 0,
            duration: 0.5,
          });
        }
      });
      slider.addEventListener("mouseout", () => {
        if (!document.documentElement.classList.contains("touch")) {
          gsap.to(hiddenP, {
            height: 0,
          });
          gsap.to(text, {
            y: 150,
            duration: 0.5,
          });
        }
      });
    });
  }
};
